import React from 'react';

function captureSentryException(error, info) {
  if (process.env.REACT_APP_SENTRY_DSN) {
    import('@sentry/react').then((Sentry) => {
      Sentry.captureException(error, { extra: { componentStack: info?.componentStack } });
    });
  }
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary] Uncaught render error:', error, info?.componentStack);
    captureSentryException(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: 24,
          textAlign: 'center',
          background: '#0f172a',
          color: '#e2e8f0',
          fontFamily: 'inherit',
        }}>
          <span style={{ fontSize: 40 }}>⚠️</span>
          <p style={{ fontWeight: 600, fontSize: 16 }}>Something went wrong.</p>
          <p style={{ fontSize: 13, color: '#94a3b8', maxWidth: 420 }}>
            {this.state.error?.message?.slice(0, 200) || 'An unexpected error occurred while rendering the page.'}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: '8px 16px',
              background: '#6366f1',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: 13,
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
